import { SlideShow } from "../slideShow";
import React from "react";
import { Presentation } from "../../lib/types";
import { Link } from "react-router-dom";
import presentation from "../../slides/sample";
import { toUrlString } from "../../lib/url-util";

interface SlideShowPageProps {
	presentations: Presentation[];
	match?: QueryStringParams;
}

export interface QueryStringParams {
	params: {
		slide: number;
		name: string;
	};
}

const SlideShowPage = (props: SlideShowPageProps) => {
	const requestedSlide = props.match?.params?.slide ?? 0;
	const currentUrl = toUrlString(props.match?.params?.name);
	debugger;
	const matchingPresentations = props.presentations.filter(
		(p) => toUrlString(p.title) === currentUrl
	);

	return (
		<>
			{matchingPresentations.length > 0 ? (
				<SlideShow
					slideIndex={requestedSlide}
					presentation={matchingPresentations[0]}
				/>
			) : (
				<>
					<style>{"* { font-family: 'Arial'}"}</style>
					<h1>
						No presentation found with name:{" "}
						{props.match?.params?.name}
					</h1>
					<Link to="/">Go back</Link>
				</>
			)}
		</>
	);
};
export { SlideShowPage };
